import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../components/AdminLayout";
import { apiRequest } from "../services/api";

function AdminProductsPage() {
  const [products, setProducts] = useState([]);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  async function fetchProducts() {
    try {
      const data = await apiRequest("/products");
      setProducts(data);
    } catch (err) {
      console.error("Failed to fetch products:", err);
    }
  }

  useEffect(() => {
    fetchProducts();
  }, []);

  async function handleDelete(productId) {
    try {
      const data = await apiRequest(`/products/${productId}`, {
        method: "DELETE",
        auth: true,
      });
      setMessage(data.message);
      fetchProducts();
    } catch (err) {
      if (err.status === 401 || err.status === 403) {
        navigate("/admin/login");
        return;
      }
      console.error("Delete product error:", err);
    }
  }

  return (
    <AdminLayout
      title="Products Dashboard"
      rightContent={
        <span
          style={{
            color: "#6b7280",
            fontSize: "14px",
          }}
        >
          Total Products: {products.length}
        </span>
      }
    >
      {message && (
        <p
          style={{
            marginTop: 0,
            marginBottom: "16px",
            color: "#16a34a",
            fontWeight: "bold",
          }}
        >
          {message}
        </p>
      )}

      {products.length === 0 ? (
        <div style={cardStyle}>
          <p style={{ color: "#6b7280", margin: 0 }}>No products found.</p>
        </div>
      ) : (
        <div style={cardStyle}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr style={{ borderBottom: "1px solid #e5e7eb" }}>
                <th style={thStyle}>ID</th>
                <th style={thStyle}>Name</th>
                <th style={thStyle}>Category</th>
                <th style={thStyle}>Price</th>
                <th style={thStyle}>Description</th>
                <th style={thStyle}>Image</th>
                <th style={thStyle}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {products.map((product) => (
                <tr
                  key={product.id}
                  style={{ borderBottom: "1px solid #f1f5f9" }}
                >
                  <td style={tdStyle}>{product.id}</td>
                  <td style={tdStyle}>{product.name}</td>
                  <td style={tdStyle}>{product.category}</td>
                  <td style={tdStyle}>₹{product.price}</td>
                  <td style={tdStyle}>{product.description}</td>
                  <td style={tdStyle}>{product.image}</td>
                  <td style={tdStyle}>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <button
                        onClick={() =>
                          navigate(`/admin/edit-product/${product.id}`)
                        }
                        style={editButton}
                      >
                        Edit
                      </button>

                      <button
                        onClick={() => handleDelete(product.id)}
                        style={deleteButton}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminLayout>
  );
}

const cardStyle = {
  background: "white",
  borderRadius: "16px",
  padding: "20px",
  boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
  overflowX: "auto",
};

const thStyle = {
  textAlign: "left",
  padding: "12px",
  color: "#374151",
  fontSize: "14px",
};

const tdStyle = {
  padding: "12px",
  color: "#111827",
  fontSize: "14px",
  verticalAlign: "top",
};

const editButton = {
  background: "#2563eb",
  color: "white",
  border: "none",
  padding: "8px 12px",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "bold",
};

const deleteButton = {
  background: "#dc2626",
  color: "white",
  border: "none",
  padding: "8px 12px",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "bold",
};

export default AdminProductsPage;
